import actions from "actions";
import constants from "constants";
import React from "react";
import { connect } from "react-redux";

const {
  hideModal,
  adminDeleteWebinarSaga,
  adminDeleteUserSaga,
  adminDeleteSponsorSaga,
  adminDeletePartnerSaga,
  adminDeleteDisciplineSaga,
  adminDeleteBookingSaga,
  deleteSuperhosts,
  deleteStudygroups,
  deleteStudyGroupWebinars,
  deleteCourseMaterials,
  deleteGroupMember,
  deleteGroupInvite,
  deleteClientUrlSaga,
} = actions;

const { MODAL_DELETE_CONFIRMATION_TYPE } = constants;

const ConfirmationModal = ({
  adminDeleteWebinarsSaga,
  contentProps,
  adminDeleteUsersSaga,
  adminDeleteSponsorsSaga,
  adminDeletePartnersSaga,
  adminDeleteDisciplinesSaga,
  hideModal,
  adminDeleteBookingSaga,
  deleteSuperhosts,
  deleteStudygroups,
  deleteGroupWebinars,
  deleteCourseMaterials,
  deleteGroupMember,
  deleteGroupInvite,
  deleteClientUrl,
}) => {
  const { type, ids, query, payload } = contentProps || {};
  const deleteAcion = () => {
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.webinar) {
      adminDeleteWebinarsSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.user) {
      adminDeleteUsersSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.sponsor) {
      adminDeleteSponsorsSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.partner) {
      adminDeletePartnersSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.discipline) {
      adminDeleteDisciplinesSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.booking) {
      adminDeleteBookingSaga(ids, query);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.superhost) {
      deleteSuperhosts(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.studygroups) {
      deleteStudygroups(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.groupWebinar) {
      deleteGroupWebinars({ ids, query });
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.courseMaterials) {
      deleteCourseMaterials(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.groupMember) {
      deleteGroupMember(payload);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.groupInvite) {
      deleteGroupInvite(payload);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.clientUrls) {
      deleteClientUrl(ids);
    }
    hideModal();
  };
  return (
    <div className="action-confirmation">
      <h5 className="title">
        Are you sure you want to delete
        {(type === MODAL_DELETE_CONFIRMATION_TYPE.webinar ||
          type === MODAL_DELETE_CONFIRMATION_TYPE.groupWebinar) &&
          " these webinars?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.user && " these users?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.sponsor && " these sponsors?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.partner && " these partners?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.discipline &&
          " these disciplines?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.booking && " these bookings?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.superhost &&
          " these super hosts?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.studygroups &&
          " these MedMeetings?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.courseMaterials &&
          " course materials?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.groupMember && " this member?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.groupInvite && " this invite?"}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.clientUrls &&
          " this client urls?"}
      </h5>
      <div className="actions">
        <button className="delete-action" onClick={deleteAcion}>
          Yes, Delete
        </button>
        <button className="cancel-action" onClick={hideModal}>
          Cancel
        </button>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    contentProps: state.modal.modalContentProps,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    adminDeleteBookingSaga: (ids, query) =>
      dispatch(adminDeleteBookingSaga(ids, query)),
    adminDeleteWebinarsSaga: (ids) => dispatch(adminDeleteWebinarSaga(ids)),
    deleteGroupWebinars: ({ ids, query }) =>
      dispatch(deleteStudyGroupWebinars({ ids, query })),
    deleteGroupMember: (payload) => dispatch(deleteGroupMember(payload)),
    deleteGroupInvite: (payload) => dispatch(deleteGroupInvite(payload)),
    adminDeleteUsersSaga: (ids) => dispatch(adminDeleteUserSaga(ids)),
    adminDeleteSponsorsSaga: (ids) => dispatch(adminDeleteSponsorSaga(ids)),
    adminDeletePartnersSaga: (ids) => dispatch(adminDeletePartnerSaga(ids)),
    adminDeleteDisciplinesSaga: (ids) =>
      dispatch(adminDeleteDisciplineSaga(ids)),
    deleteSuperhosts: (ids) => dispatch(deleteSuperhosts(ids)),
    deleteStudygroups: (ids) => dispatch(deleteStudygroups(ids)),
    deleteCourseMaterials: (ids) => dispatch(deleteCourseMaterials(ids)),
    deleteClientUrl: (ids) => dispatch(deleteClientUrlSaga(ids)),
    hideModal: () => dispatch(hideModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);



// WEBPACK FOOTER //
// ./src/containers/Admin/ConfirmationModal/index.js